import { graphql } from "react-relay";

export const QUERY_FRAGMENT = graphql`
	fragment discountActionsTable_QueryFragment on Query
	@refetchable(queryName: "DiscountActionsTable_QueryFragmentRefetch")
	@argumentDefinitions(
		first: { type: "Int" }
		last: { type: "Int" }
		after: { type: "String", defaultValue: null }
		before: { type: "String", defaultValue: null }
		filterByDiscountTypeKind: { type: "DiscountTypeKindInput" }
		filterByActionTitle: { type: "String" }
		filterByCode: { type: "String" }
		filterByIsArchived: { type: "Boolean" }
	) {
		Admin {
			Billing {
				DiscountActions(
					after: $after
					before: $before
					first: $first
					last: $last
					filterByDiscountTypeKind: $filterByDiscountTypeKind
					filterByActionTitle: $filterByActionTitle
					filterByCode: $filterByCode
					filterByIsArchived: $filterByIsArchived
				) @connection(key: "DiscountActionsTable_DiscountActions") {
					__id
					pageInfo {
						startCursor
						endCursor
						hasNextPage
						hasPreviousPage
					}
					edges {
						cursor
						node {
							...discountActionsTable_DiscountActionFragment
						}
					}
				}
			}
		}
	}
`;

export const DISCOUNT_ACTION_FRAGMENT = graphql`
	fragment discountActionsTable_DiscountActionFragment on DiscountAction @inline {
		id
		title
		percent
		isReductible
		discountType {
			kind
		}
	}
`;
